<app-card [title]="board.nombre" [favorite]="board.favorito" (favoriteEvent)="onFavorite($event)">
  <p *ngIf="board.descripcion" class="description">{{ board.descripcion }}</p>
  <div class="options dropdown-center">
      <button type="button" class="btn" class="btn-generate" (click)="loadEmbeddedBoard()">
          Ver
      </button>
      <button *ngIf="canInactivate" class="ellipsis" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-icon class="icon" [icon]="faEllipsis"></fa-icon>
    </button>
    <ul class="dropdown-menu">
        <li><button class=" dropdown-item" (click)="deleteBoard(board)">Eliminar</button></li>
    </ul>
  </div>
</app-card>